"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledMenuItem = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _Button = _interopRequireDefault(require("../Button"));
var _Throbber = _interopRequireDefault(require("../Throbber"));
var _HotelMenuPrice = _interopRequireDefault(require("./HotelMenuPrice"));
var _excluded = ["menuItems", "active", "minPrice", "fetching", "onMenuItemClicked", "onShowToursClicked", "isHotelOnly"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelMenuBar = function HotelMenuBar(_ref) {
  var menuItems = _ref.menuItems,
    active = _ref.active,
    minPrice = _ref.minPrice,
    fetching = _ref.fetching,
    onMenuItemClicked = _ref.onMenuItemClicked,
    onShowToursClicked = _ref.onShowToursClicked,
    isHotelOnly = _ref.isHotelOnly,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledContainer, props, /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, menuItems.map(function (_ref2) {
    var id = _ref2.id,
      label = _ref2.label,
      disabled = _ref2.disabled;
    return /*#__PURE__*/_react["default"].createElement(StyledMenuItem, {
      key: id,
      active: id === active,
      disabled: disabled,
      onClick: function onClick() {
        return onMenuItemClicked(id);
      }
    }, label);
  })), /*#__PURE__*/_react["default"].createElement(StyledWrapper, null, !fetching && /*#__PURE__*/_react["default"].createElement(StyledMenuPrice, {
    price: minPrice,
    isHotelOnly: isHotelOnly
  }), /*#__PURE__*/_react["default"].createElement(StyledButton, {
    onClick: onShowToursClicked,
    disabled: fetching
  }, fetching ? /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
    size: 15,
    thickness: 1,
    color: "blue"
  }) : minPrice && "".concat(isHotelOnly ? t('hotel.menuBar.hotelOnly') : t('hotel.menuBar.tour')) || t('hotel.menuBar.changeDate'))));
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelMenuBar__StyledContainer",
  componentId: "sc-1818c6k-0"
})(["display:flex;align-items:center;justify-content:space-between;height:48px;background-color:var(--white);padding:8px 8px 8px 16px;"]);
var StyledWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelMenuBar__StyledWrapper",
  componentId: "sc-1818c6k-1"
})(["display:flex;align-items:center;"]);
var StyledButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "HotelMenuBar__StyledButton",
  componentId: "sc-1818c6k-2"
})(["height:auto;width:auto;padding:8px 12px;font-size:14px;font-style:normal;font-weight:400;line-height:16px;"]);
var StyledMenuPrice = (0, _styledComponents["default"])(_HotelMenuPrice["default"]).withConfig({
  displayName: "HotelMenuBar__StyledMenuPrice",
  componentId: "sc-1818c6k-3"
})(["margin-right:16px;"]);
var StyledMenuItem = exports.StyledMenuItem = (0, _styledComponents["default"])(_Button["default"]).attrs({
  functional: true
}).withConfig({
  displayName: "HotelMenuBar__StyledMenuItem",
  componentId: "sc-1818c6k-4"
})(["font-size:14px;font-style:normal;font-weight:400;line-height:16px;", ";cursor:", ";text-decoration:", ";pointer-events:", ";margin-right:24px;:hover{color:var(--secondary);}"], function (props) {
  return props.active ? (0, _styledComponents.css)(["color:var(--black);"]) : props.disabled && (0, _styledComponents.css)(["opacity:var(--disabled-opacity);"]) || (0, _styledComponents.css)(["color:var(--grey1);"]);
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.disabled ? 'line-through' : 'none';
}, function (props) {
  return props.disabled ? 'none' : 'default';
});
HotelMenuBar.defaultProps = {
  active: undefined,
  fetching: false,
  minPrice: null
};
HotelMenuBar.propTypes = {
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].node.isRequired,
    disabled: _propTypes["default"].bool
  })).isRequired,
  active: _propTypes["default"].string,
  fetching: _propTypes["default"].bool,
  minPrice: _propTypes["default"].number,
  onMenuItemClicked: _propTypes["default"].func.isRequired,
  onShowToursClicked: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelMenuBar);